<template>
  <div id="result" class="div_card">
    <div v-if="docRecord==null">      
      <el-alert
        title="資料讀取中…"
        type="info"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div>
    <div v-else-if="docRecord!=null && docRecord.status==2"> 
      <el-alert
        title="您未辦理報到作業!!"
        type="error"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div>
    <div v-else-if="docRecord!=null && docRecord.status==1">
      <div class="">
        <div class="">
          <table class="w-100" style="background-color: azure; border: gray;" rules="all" bgcolor="#FFFFFF" >
            <thead>
              <tr>
                <th colspan="4" class="ncut-base-form-title" style="background-color: orange; text-align:left; padding: 0.5em;">資料狀態如下:</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="ncut-base-form-title" style="width: 14%;padding:0.5em;">考生姓名</td>
                <td style="padding:0.1em;">
                  <span class="badge badge-info" style="font-size:1.25rem">{{docRecord.name}}</span>
                </td>
                <td class="ncut-base-form-title" style="width: 14%;padding:0.5em;">報名編號</td>
                <td style="padding:0.1em;">
                  <span class="badge badge-info" style="font-size:1.25rem">{{docRecord.regNo}}</span>
                </td>
              </tr>              
              <tr>
                <td class="ncut-base-form-title" style="padding:0.5em;">就讀意願確認狀態</td>
                <td colspan="3" style="padding:0.1em;">
                  <span class="badge" style="font-size: 1.5rem"
                        v-bind:style="{'background': statusColor}">{{docRecord.isCheck==1 ? "已確認" : "未完成"}}</span>
                </td>
              </tr>           
              <tr>
                <td class="ncut-base-form-title ncut-require-title" style="padding:0.5em;">聯絡電話</td>
                <td colspan="3" style="padding:0.1em;">
                  <el-input v-model="docRecord.phoneNo1" style="width:9.375em;" :maxlength="20" :disabled="docRecord.isCheck!=0"></el-input> 
                  <font size="+1" color="#003399" style="margin: 0;margin-bottom: 1em;font-size: 100%;font-weight: bolder;">
            (訊息聯絡用)</font>
                </td>
              </tr>    
              <tr>
                <td class="ncut-base-form-title ncut-require-title" style="padding:0.5em;">考生手機</td>
                <td colspan="3" style="padding:0.1em;">
                  <el-input v-model="docRecord.phoneNo2" style="width:9.375em;" :maxlength="20" :disabled="docRecord.isCheck!=0"></el-input> 
                  <font size="+1" color="#003399" style="margin: 0;margin-bottom: 1em;font-size: 100%;font-weight: bolder;">
            (訊息聯絡用，請確認手機號碼無誤)</font>
                </td>
              </tr>        
              <tr>
                <td class="ncut-base-form-title ncut-require-title" style="padding:0.5em;">E-mail</td>
                <td colspan="3" style="padding:0.1em;">
                  <el-input v-model="docRecord.eMail" style="width:25.375em;" :maxlength="50" :disabled="docRecord.isCheck!=0"></el-input>                   
                </td>
              </tr>
              <tr>
                <td class="ncut-base-form-title ncut-require-title" style="padding:0.1em 0.5em 0.1em 0; vertical-align: middle;">通訊地址<br /><font style="font-size:small;">(9月底前可聯絡地址)</font></td>
                <td class="ncut-ipnut-form-ipt" colspan="3">                        
                        <div class="input-group" style="display:flex; padding:0.2em;">
                          <span class="ncut-ipnut-form-text">縣市鄉鎮</span>&nbsp;
                          <el-select v-model="docRecord.mailCity" placeholder="請選擇縣市"
                              style="width: 8em;"
                              @change="districtItem2=null; docRecord.mailDistrict=null; getMailDistrictItem();"   
                              :disabled="docRecord.isCheck!=0"                           
                              v-if="cityItem!=null">
                              <el-option
                                v-for="item in cityItem"
                                :key="item.codeNo"
                                :label="item.zipName"
                                :value="item.codeNo">
                              </el-option>
                              <el-option key="0" label="無" :value="0" :disabled="true"></el-option>
                          </el-select>&nbsp;&nbsp;&nbsp;&nbsp;
                          <el-select v-model="docRecord.mailDistrict" placeholder="請選擇鄉鎮"
                              style="width: 8em;" :disabled="docRecord.isCheck!=0">
                              <el-option
                                v-for="item in districtItem2"
                                :key="item.codeNo"
                                :label="item.zipName"
                                :value="item.codeNo">
                              </el-option>
                              <el-option key="0" label="無" :value="0" :disabled="true"></el-option>
                          </el-select>&nbsp;&nbsp;&nbsp;&nbsp;
                          <el-input v-if="this.windowWidth >= 992" v-model="docRecord.mailAddress" placeholder="請輸入地址" style="width: 30em; display: inline; " maxlength="60" :disabled="docRecord.isCheck!=0"></el-input>                          
                        </div>
                        <div class="input-group" v-if="this.windowWidth < 992">
                          <el-input v-model="docRecord.mailAddress" placeholder="請輸入地址" style="width: 30em; display: inline; " maxlength="60" :disabled="docRecord.isCheck!=0"></el-input>
                        </div>
                </td>
              </tr>
              <tr v-show="docRecord.isCheck==0">                
                <td class="ncut-ipnut-form-ipt" colspan="4" style="padding: 0.5em; text-align: center;">                  
                    <el-button type="success" @click="submit()" >確認無誤<i class="el-icon-success el-icon--right"/></el-button>
                    <div style="display: block; font-size:1rem;">
                    確認或編輯資料無誤後，請務必點選上方「確認無誤」鈕，確認後即無法再修改! 
                    </div>                               
                </td>
              </tr>
              <tr>
                <td class="ncut-base-form-title">備註</td>
                <td colspan="3" style="padding: 0.5em;">
                  <div style="padding: 0.5em 0 0;" 
                    v-html="docRecord.entName"/>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-else-if="docRecord!=null && docRecord.status==5">
      <el-alert
        title="請先完成網路報名。"
        type="error"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div>
    <div v-else>
      <el-alert
        title="尚無資料，請耐心等候，謝謝!!"
        type="warning"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div> 
  </div> 
</template>


<script>
export default {
  name: 'result',
  data () {
    return {
      windowWidth: window.innerWidth,
      docRecord: null,
      districtItem2: null,
      cityItem: null,
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
    enroll () {
      return this.$store.getters.getEnrollInfo
    },
    user () {
      return this.$store.getters.getUser
    },
    statusColor () {
      let url = '#d9534f';

      if (null != this.docRecord) {        
        switch(this.docRecord.isCheck) {
          case 1:
            url = '#5cb85c';
            break;          
        }  
      }
      return url
    }
  },
  filters: {
    numFilter(value) {
      let realVal = parseFloat(value).toFixed(2)
      return parseFloat(realVal)
    }
  },
  methods: {
    isNull(data) {
      return ((data != null) && (data != undefined) && (data != "null") ? false : true);
    },
    showErrorMsg(vm, msg) {
      vm.$notify.error({
                        title: vm.$t('message.Error_txt'),
                        dangerouslyUseHTMLString: true,
                        message: msg,
                        offset: 150
                      });
    },
    getMailDistrictItem(idx) {
      var cityName = this.docRecord.mailCity + '';

      if ((null == this.districtItem2) && (cityName != null) && (cityName != undefined) && (cityName.length > 0)) {
        let vm = this
        this.$http
            .get("./WebApi/Setting/GetZipItem/"+cityName)
            .then(function(response) {
              if (null != response.data) {
                vm.districtItem2 = response.data;
              }
            })
            .catch(function (error) {
              vm.$notify.error({
                                title: vm.$t('message.Error_txt'),
                                dangerouslyUseHTMLString: true,
                                message: '<strong>對不起,網路連線失敗</strong>',
                                offset: 150
                              });
            });
      }
    },
    getCityItem() {
      if (this.cityItem == null) { 
        let vm = this
        this.$http
            .get("./WebApi/Setting/GetZipItem/00")
            .then(function(response) {
              if (null != response.data) {
                vm.cityItem = response.data;
              }
            })
            .catch(function (error) {
              vm.$notify.error({
                                title: vm.$t('message.Error_txt'),
                                dangerouslyUseHTMLString: true,
                                message: '<strong>對不起,網路連線失敗</strong>',
                                offset: 150
                              });
            });
      }
    },
    onResize() {
      this.windowHeight = window.innerHeight;
      this.windowWidth =  window.innerWidth;
    },
    loadInfoList() {
      var vm = this
      this.$http
        .get('./WebApi/Apply/GetChkResult/'.concat(this.user.hId))
        .then(function(response) {
          if (response.data != null) {
            vm.docRecord = response.data;
            vm.getCityItem();
            if ((null != vm.docRecord.mailCity) && (0 < vm.docRecord.mailCity)) {
                  vm.getMailDistrictItem();
                }            
          } else {
            vm.showErrorMsg(vm, '<strong>對不起,讀取<i style="background:yellow;">狀態</i>查詢失敗:'+error+'</strong>');
          }
        })
        .catch(function (error) {
          vm.showErrorMsg(vm, '<strong>對不起,網路連線失敗' + error+'</strong>');
        })
    },
    isEmpty(data) {
      return ((data != null) && (data != undefined) && (data.length > 0) ? false : true);
    },
    isSuccess(str) {
      return ((str == "true") || (str == "True") || (str == true) ? true : false);
    },
    checkQueryData () {
      var reg=/^09\d{8}$/;
      let msg = ''; 
      if (this.isEmpty(this.docRecord.phoneNo1)) {
        msg = '輸入聯絡電話';
      } else if(!reg.test(this.docRecord.phoneNo2)){ 
        msg = '有效的手機號碼';                    
      }else if (this.isEmpty(this.docRecord.phoneNo2)) {
        msg = '輸入手機號碼';
      }else if (this.isEmpty(this.docRecord.eMail)) {
        msg = '輸入E-mail';
      }else if (this.isNull(this.docRecord.mailCity) || (0 == this.docRecord.mailCity) || this.isNull(this.docRecord.mailDistrict) || (0 == this.docRecord.mailDistrict) || this.isEmpty(this.docRecord.mailAddress)) {
        msg = '輸入通訊地址';
      }
      return msg;
    },
    submit() {
      var msg = this.checkQueryData();      
      var vm = this;
      
      if (0 == msg.length) {
        vm.docRecord.updateUser = vm.user.id;
        this.$http.put('./WebApi/Apply/SetCheckInfo',this.docRecord)
                .then((response) =>{
                  if (true == vm.isSuccess(response.data)) {
                    vm.$message({
                                        message: '恭喜您,存檔成功',
                                        type: 'success'
                                      });
                              
                              vm.loadInfoList();                    
                  } else {
                    //vm.$message.error('對不起,網路連線失敗' + error);
                    vm.$notify.error({
                                      title: vm.$t('message.Error_txt'),
                                      message: '對不起,網路連線失敗',
                                      offset: 150
                                    });
                  }
                })
                .catch(function (error) {
                  //vm.$message.error('對不起,網路連線失敗');
                  vm.$notify.error({
                                    title: vm.$t('message.Error_txt'),
                                    dangerouslyUseHTMLString: true,
                                    message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                                    offset: 150
                                  });
                })
      } else {
        vm.$notify.error({
                                    title: vm.$t('message.Error_txt'),
                                    dangerouslyUseHTMLString: true,
                                    message: '<strong>對不起,請輸入' + msg+'</strong>',
                                    offset: 150
                                  });        
      }
    }
  },
  mounted() {    
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },
  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
  },
  created () { 
    console.log('======created ResultChkView=====') 
    this.loadInfoList();    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/TranCheckView.vue